var _excluded = ["type"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Icon } from 'semantic-ui-react';
import { jsx as _jsx } from "react/jsx-runtime";
export var ClearIcon = function ClearIcon(props) {
  return /*#__PURE__*/_jsx(Icon, Object.assign({
    link: true,
    name: "cancel"
  }, props));
};
ClearIcon.handledProps = [];
export var SuperPrevIcon = function SuperPrevIcon(props) {
  return /*#__PURE__*/_jsx(Icon, Object.assign({
    link: true,
    name: "angle double left"
  }, props));
};
SuperPrevIcon.handledProps = [];
export var PrevIcon = function PrevIcon(props) {
  return /*#__PURE__*/_jsx(Icon, Object.assign({
    link: true,
    name: "angle left"
  }, props));
};
PrevIcon.handledProps = [];
export var NextIcon = function NextIcon(props) {
  return /*#__PURE__*/_jsx(Icon, Object.assign({
    link: true,
    name: "angle right"
  }, props));
};
NextIcon.handledProps = [];
export var SuperNextIcon = function SuperNextIcon(props) {
  return /*#__PURE__*/_jsx(Icon, Object.assign({
    link: true,
    name: "angle double right"
  }, props));
};

// eslint-disable-next-line react/prop-types
SuperNextIcon.handledProps = [];
export var SuffixIcon = function SuffixIcon(_ref) {
  var type = _ref.type,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Icon, Object.assign({
    link: true,
    name: type === 'time' ? 'clock outline' : 'calendar alternate outline'
  }, rest));
};
SuffixIcon.handledProps = [];
export var RangeSeparatorIcon = function RangeSeparatorIcon(props) {
  return /*#__PURE__*/_jsx(Icon, Object.assign({
    name: "arrow right"
  }, props));
};
RangeSeparatorIcon.handledProps = [];